import { pxToRem, scrollbar, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { PleditorContainer, PleditorSidebar } from '../../../styled';
export const RHContainer = styled(PleditorContainer) `
  display: none;
  overflow: hidden;
  padding-bottom: 0;
  height: 100%;
  width: 100%;

  .ck.ck-editor__top.ck-reset_all {
    display: none;
  }

  .ck.ck-editor__main {
    min-width: ${pxToRem(823)}; /* Taken from the document's rendered width */
    min-height: 100%;
    height: 100%;
    overflow: auto;

    ${scrollbar({ trackMargin: 'xl' })};

    & > .ck-content {
      border-color: transparent;
    }
  }
`;
export const RHContentContainer = styled.div `
  width: fit-content;
  display: block;
  margin: 0 auto;
  height: 100%;
`;
export const RHContentInnerContainer = styled.div `
  display: inline-flex;
  justify-content: space-between;
  height: 100%;
`;
export const RHSidebar = styled(PleditorSidebar) `
  height: 100%;
  overflow: auto;
  color: ${theme.semantic.foreground.primary};

  ${scrollbar({ trackMargin: 'xl' })};

  /* Revision History Sidebar Header */
  .ck-revision-history-sidebar__header {
    border-bottom: unset;
    padding-left: ${theme.spacing['2xl']};
  }

  /* Revision History Sidebar */
  .ck.ck-revision-history-sidebar {
    height: 100%;
  }

  /* Revision History Sidebar Revision Items Wrapper */
  .ck.ck-revision-history-sidebar .ck-revision-history-sidebar__timeline {
    padding-left: ${theme.spacing['2xl']};
    padding-right: ${theme.spacing['2xl']};
  }

  /* Revision History Sidebar Time Period */
  .ck.ck-revision-history-sidebar__time-period .ck-revision-history-sidebar__time-period__label {
    text-transform: capitalize;
    padding: 0;
    background-color: transparent;
    font-size: ${theme.fontSize.small};
    font-weight: ${theme.fontWeight.medium};
    color: ${theme.semantic.foreground.secondary};
  }

  /* Revision History Sidebar Revision Item */
  .ck .ck-revision-history-sidebar__revision-wrapper .ck-revision-history-sidebar__revision {
    border-radius: ${theme.borderRadius.md};
    border: solid ${pxToRem(1)} ${theme.semantic.border.default};
    cursor: pointer;
    color: ${theme.semantic.foreground.primary};
    padding: ${theme.spacing.md};
    box-shadow: none;
  }

  /* Revision History Sidebar Revision Item Selected */
  .ck
    .ck-revision-history-sidebar__revision-wrapper
    .ck-revision-history-sidebar__revision.ck-revision-history-sidebar__revision_selected {
    background-color: ${theme.semantic.surface.sunken};
  }

  /* Revision History Sidebar Revision Item Dropdown Button */
  .ck .ck-revision-history-sidebar__revision .ck-revision-history-sidebar__revision__actions .ck-dropdown__button {
    background: transparent;
    border-radius: ${theme.borderRadius.md};
  }

  /* Revision History Sidebar Revision Item Dropdown Button Icon */
  .ck
    .ck-revision-history-sidebar__revision
    .ck-revision-history-sidebar__revision__actions
    .ck-dropdown__button
    .ck-button__icon {
    transform: scale(1);
  }

  /* Revision History Sidebar Revision Item Dropdown Item */
  .ck .ck-revision-history-sidebar__revision .ck-dropdown__panel {
    color: ${theme.semantic.foreground.primary};
  }

  /* Revision History Sidebar Revision Item Authors Icon */
  .ck.ck-revision-history-sidebar__revision-authors .ck-icon {
    display: none;
  }

  /* Revision History Sidebar Revision Item Authors */
  .ck.ck-revision-history-sidebar__revision-authors {
    --ck-revision-history-revision-author-icon-offset: 0;
  }

  /* Revision History Sidebar Revision Item Authors Name */
  .ck.ck-revision-history-sidebar__revision-author .ck-revision-history-sidebar__revision-author__name {
    color: ${theme.semantic.text[100]};
    font-weight: ${theme.fontWeight.regular};
  }

  /* Revision History Sidebar Revision Item Date */
  .ck.ck-revision-history-sidebar__revision-wrapper
    .ck-revision-history-sidebar__revision
    .ck-revision-history-sidebar__revision__date {
    font-size: ${theme.fontSize.tiny};
    font-weight: ${theme.fontWeight.regular};
    color: ${theme.semantic.text[100]};
  }

  /* Revision History Sidebar Revision Item Controls Wrapper */
  .ck.ck-revision-history-sidebar__revision-wrapper
    .ck-revision-history-sidebar__revision
    .ck-revision-history-sidebar__revision__controls-wrapper {
    margin: 0;
    font-size: ${theme.fontSize.tiny};
  }

  /* Revision History Sidebar Revision Item Name */
  .ck.ck-revision-history-sidebar__revision-name > .ck-labeled-field-view__input-wrapper > .ck-input {
    font-weight: ${theme.fontWeight.regular};
    color: ${theme.semantic.foreground.primary};
    font-size: ${theme.fontSize.small};
  }

  /* Revision History Sidebar Revision Item Name Selected */
  .ck.ck-revision-history-sidebar__revision-wrapper
    .ck-revision-history-sidebar__revision.ck-revision-history-sidebar__revision_selected
    .ck-revision-history-sidebar__revision-name
    .ck-input {
    color: inherit;
  }

  /* Revision History Sidebar Revision Item Dropdown Button */
  .ck.ck-revision-history-sidebar__revision .ck-revision-history-sidebar__revision__actions {
    top: ${theme.spacing.md};
    right: ${theme.spacing.md};
    display: block;

    & > button {
      cursor: pointer;
      background: transparent;
      transition: background 175ms ease-in-out;

      &:hover,
      &.ck-dropdown__button.ck-on {
        background: color-mix(in srgb, ${theme.semantic.surface.inverse}, transparent 85%) !important;
      }
    }
  }

  /* Revision History Sidebar Revision Item Dropdown Button Icon */
  .ck.ck-icon.ck-icon_inherit-color {
    color: ${theme.semantic.foreground.tertiary};
  }
`;
export const RHEditor = styled.div ``;
